import { defineComponent } from 'vue';
import { Button } from '@yellowcard/components-library-vue3';
import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
import router from '@/router';
import { TransactTypes } from '@/types/transact';
export default defineComponent({
    name: 'MinipayTransactionError',
    components: {
        Button,
    },
    setup() {
        const transactionStore = useTransactionsStore();
        const { minipayError, currentStep } = storeToRefs(transactionStore);
        async function goHome() {
            router.push('/');
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        }
        return {
            minipayError,
            goHome,
        };
    },
});
